export class MemoryCacheStore {
    constructor() {
        this.store = new Map();
    }
    async get(key) {
        const entry = this.store.get(key);
        if (!entry) {
            return null;
        }
        if (entry.expiresAt && Date.now() > entry.expiresAt) {
            this.store.delete(key);
            return null;
        }
        return entry.value;
    }
    async set(key, value, ttl) {
        const expiresAt = ttl ? Date.now() + ttl * 1000 : null;
        this.store.set(key, { value, expiresAt });
    }
    async delete(key) {
        this.store.delete(key);
    }
}
//# sourceMappingURL=MemoryCacheStore.js.map